import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';

async function fetchAPI(query, accessToken) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    headers: { accesstoken: accessToken },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function addToWatchlist(list_name, tickers, notes, description, columns, accessToken) {
  const data = await fetchAPI(
    `mutation {
      addToWatchlist(
        name: "${list_name}",
        tickers: [${tickers && Array.isArray(tickers) && tickers.length > 0 ? tickers?.map(d => `"${d}"`) : `"${tickers}"`}],
       ${notes ? `notes: "${notes?.replace(/"/g, "'")}",` : ``}
       ${description ? `description: "${description}"` : ``}
       ${columns ? `columns: "${columns}"` : ``}
      ) {
          status
        }}`, accessToken
  )
  return data
}

